<template>
  <div>
    <commonBanner :bgImg="bgImg" :search="false"></commonBanner>
    <DetailPageWrap
      :titleCardOptions="titleCardOptions"
      :description="resultList2"
    >
      <template>
        <div class="talent-detail-card-wrap">
          <MediaWrap class="audio-wrap" :url="imgUrl" :height="180"></MediaWrap>
          <div class="infos">
            <div class="name">{{ resultList.name }}</div>
            <div>简介: {{ resultList.introduction }}</div>
            <span class="line"></span>
            <a-row>
              <a-col :span="8">电话:{{ resultList.phone }}</a-col>
              <a-col :span="16">邮箱:{{ resultList.email }}</a-col>
            </a-row>
            <a-row class="mt20">
              <a-col :span="8">专家类型:{{ resultList.expertsTypeStr }}</a-col>
              <a-col :span="16">所属行业:{{ resultList.industryStr }}</a-col>
            </a-row>
          </div>
        </div>
      </template>
    </DetailPageWrap>
  </div>
</template>

<script>
import DetailPageWrap from '@/components/common/DetailPageWrap'
import { checkTalentData } from '@/api/MTalentData.js'
import mixinsBackStack from '@/views/backstageSupport/mixins'
import commonBanner from '@/components/common/banner'

export default {
  mixins: [mixinsBackStack],
  data() {
    return {
      resultList: [],
      resultList2: [],
      imgUrl: '',
      titleCardOptions: {
        title: '专家介绍',
        showMore: false,
        isSwitch: false
      },
      bgImg: require('@/assets/images/人才智库banner.png'),
    }
  },
  components: {
    DetailPageWrap,
    commonBanner
  },
  mounted() {
    this.initSetting() // 初始化设置
  },
  methods: {
    async initSetting() {
      const { id } = this.$route.query
      const { data } = await checkTalentData(id)
      this.handlerResultMappings([data]) // 处理数据的映射关系
      this.resultList = data
      this.resultList2 = [
        {
          contents: [
            data.info
          ]
        }
      ],
        this.imgUrl = (data.fileVo && data.fileVo[0] && data.fileVo[0].url) || require('@/assets/images/人才智库人才.png')
    },
  }
}
</script>
<style scoped>
.infos {
  width: 10rem;
}
</style>